import { WorkflowActionTypes } from 'src/app/models/RestApiCaller/Enums/workflow-action-types';
import { BaseActionData } from './base-action-data';

/**
 * Représente les données de l'action 'Arrêt minuteur'
 */
export class TimerStopActionData extends BaseActionData {
    /**
     * Identifiant du trigger à utiliser pour arrêter le trigger de type minuteur.
     */
    public workflowTriggerId: number;

    /**
     * Constructeur.
     */
    constructor() {
        super(WorkflowActionTypes.TimerStop);
    }

    /**
     * Retourne une copie d'une instance de TimerStopActionData
     * @param other : Instance source.
     * @returns : Copie de l'instance.
     */
    public static clone(other: TimerStopActionData) {
        if (!!other) {
            const instance = new TimerStopActionData();
            instance.workflowTriggerId = other.workflowTriggerId;
            instance.type = other.type;

            return instance;
        } else {
            return null;
        }
    }
}
